export default __webpack_public_path__ + "static/media/Believer's Bracers of the Soaring Heart.78daf22e.jpg";